export function clerkHostRouting(desktop: boolean): "hash" | "path" {
  return desktop ? "hash" : "path";
}

export const DESKTOP_CLERK_REDIRECT_ORIGINS = [
  "https://tauri.localhost",
  "http://tauri.localhost",
  "tauri://localhost",
] as const;

export function clerkAllowedRedirectOrigins(
  desktop: boolean,
): readonly string[] | undefined {
  return desktop ? DESKTOP_CLERK_REDIRECT_ORIGINS : undefined;
}
